import './tripDateTable.css';
import '../../dashboard/dashboardTable/dashboardTable.css';
import { useEffect, useState } from 'react';
import { standardDate } from '../../../utils/formatDate';
import { orgBookingCancelFun } from '../../../api/orgTripAPI';
import { toast } from 'react-toastify';
import errorHandle from '../../../utils/errorHandle';
import ConfirmationModal from '../../../components/tripStrap/tripStrapFun/cancelBooking';
import { ReactComponent as SortIcon } from '../../../assets/icons/sort-icon-a-z.svg';

//pagination not required as we are populating data from bookingId array.
//And data wont reach more than 200
export default function TripCustomDateTabel({ bookingData, contentData, tripStatus, setLoading, refresh }) {
    const tableHeader = [
        'Sl No',
        'Name',
        'Start City',
        'Pick Up',
        'Booked On',
        'Seats',
        'Rooms',
        'IsGroup',
        'Bed',
        'Payment',
        'Vehicle',
        'Booked Via',
        'People',
        `${tripStatus === 'Upcoming' ? 'Action' : ''}`
    ];
    const [showModal, setShowModal] = useState(false);
    const [rowId, setRowId] = useState('');
    const [sortedData, setSortedData] = useState(bookingData);
    const [pickupAsc, setPickupAsc] = useState(true);

    const getUserData = (row) => {
        return row.userDetails.map(function (user, userKey) {
            return (
                <div key={userKey}>
                    <span>{user?.name ?? 'N/A'}, </span>
                    <span>{user?.age ?? 'N/A'}, </span>
                    <span>{user?.sex ?? 'N/A'}, </span>
                    <span>{user?.phoneNumber ?? 'N/A'}</span>
                </div>
            );
        });
    };

    const getCustomVehicleData = (row) => {
        return row?.customTrip?.vehicle?.map((vehicleItem, vehicleItemKey) => {
            return (
                <div key={vehicleItemKey} className='vehicleDataDiv'>
                    {vehicleItem?.vehicleCount > 0 && (
                        <div>
                            <span>Vehicle Name:</span> {vehicleItem?.vehicleName}
                        </div>
                    )}
                    {vehicleItem?.vehicleCount > 0 && (
                        <div>
                            <span>Number of Vehicles:</span> {vehicleItem?.vehicleCount}
                        </div>
                    )}
                </div>
            );
        });
    };

    async function handleBookingCancel(e) {
        e.stopPropagation();
        setLoading(true);

        try {
            const newDate = await orgBookingCancelFun({ bookingId: rowId });
            if (newDate.status === 200) {
                toast.success('Successfully cancelled Booking');
                setShowModal(false);
                refresh();
            }
            setLoading(false);
        } catch (error) {
            setLoading(false);
            errorHandle(error);
        }
    }

    useEffect(() => {
        setSortedData(bookingData);
    }, [bookingData]);

    const handleSortByPickUp = () => {
        const sorted = [...sortedData].sort((a, b) => {
            const pickupA = a.pickupLocation?.toLowerCase() || '';
            const pickupB = b.pickupLocation?.toLowerCase() || '';
            return pickupAsc ? pickupA.localeCompare(pickupB) : pickupB.localeCompare(pickupA);
        });
        setSortedData(sorted);
        setPickupAsc(!pickupAsc);
    };

    return (
        <div className='tripDateContainer'>
            <div className='tableContainer'>
                <table className='table'>
                    <thead className='tableHead'>
                        <tr>
                            {tableHeader.map((head, headKey) => {
                                return (
                                    <th key={headKey}>
                                        <div className='table-header-flex'>
                                            {head}
                                            {head === 'Pick Up' && (
                                                <SortIcon
                                                    width={17}
                                                    height={16}
                                                    className='cursor-pointer sort-icon'
                                                    onClick={handleSortByPickUp}
                                                />
                                            )}
                                        </div>
                                    </th>
                                );
                            })}
                        </tr>
                    </thead>
                    <tbody>
                        {sortedData &&
                            sortedData.length > 0 &&
                            sortedData.map((row, rowKey) => {
                                return (
                                    <tr
                                        className={
                                            row?.tripStatus === 'Cancelled'
                                                ? 'tableBodyCancelledRow'
                                                : 'tableBodyRow allowCLick'
                                        }
                                        key={rowKey}
                                    >
                                        <td>{rowKey + 1}.</td>
                                        <td className='tripDateNameRow'>{row?.userDetails[0]?.name ?? 'N/A'}</td>
                                        <td>{row?.startCity ?? 'N/A'}</td>
                                        <td>{row?.pickupLocation ?? 'N/A'}</td>
                                        <td>{standardDate(row?.createdAt?.split('T')[0])}</td>
                                        <td>{row?.totalSeats ?? '0'}</td>
                                        <td>{row?.customTrip?.rooms.length ?? '0'}</td>
                                        <td>{row?.customTrip?.isGroup ? 'Yes' : 'No'}</td>
                                        <td>{row?.customTrip?.bed ?? '0'}</td>
                                        <td
                                            style={{
                                                color:
                                                    row?.amountPaid?.isReserved || row?.amountPaid?.isInstallment
                                                        ? 'red'
                                                        : '',
                                                textAlign: 'center',
                                                whiteSpace: 'pre-line',
                                                verticalAlign: 'middle'
                                            }}
                                        >
                                            {row?.amountPaid?.isReserved || row?.amountPaid?.isInstallment
                                                ? `${row?.amountPaid?.isReserved ? 'Reserved' : 'Installment'}\n${
                                                      row?.amountPaid?.isReserved
                                                          ? `(₹${row?.amountPaid?.reserve}/seat)`
                                                          : row?.amountPaid?.isInstallment
                                                            ? `(₹${row?.amountPaid?.amount})`
                                                            : ''
                                                  }
                                              Total: ${row?.amountPaid?.total}
                                              Paid: ${row?.amountPaid?.paid}
                                              Balance: ${row?.amountPaid?.total - row?.amountPaid?.paid}`
                                                : <>Full payment<br />Paid: ₹{Number(row?.amountPaid?.paid) || 0}</>}
                                        </td>
                                        <td>{getCustomVehicleData(row) ?? 'N/A'}</td>
                                        <td>{row?.bookedVia ?? 'N/A'}</td>
                                        <td>{getUserData(row)}</td>
                                        {tripStatus === 'Upcoming' ? (
                                            row?.tripStatus === 'Cancelled' ? (
                                                <td>{row?.tripStatus}</td>
                                            ) : (
                                                <td>
                                                    <span
                                                        className='cancelTrip-btn'
                                                        onClick={() => {
                                                            setShowModal(true);
                                                            setRowId(row._id);
                                                        }}
                                                    >
                                                        Cancel
                                                    </span>
                                                </td>
                                            )
                                        ) : (
                                            <></>
                                        )}
                                    </tr>
                                );
                            })}
                    </tbody>
                </table>
                <div className='responsiveCardContainer'>
                    {sortedData &&
                        sortedData.length > 0 &&
                        sortedData?.map((row, rowIndex) => (
                            <div key={rowIndex} className={`responsiveCard ${row?.tripStatus?.toLowerCase()}`}>
                                <div className='cardContent'>
                                    <h3>{row.userDetails[0].name}</h3>
                                    {/* {contentData.group === 'vehicle' && (
                                        <p>
                                            <strong>{tableHeader[2]}:</strong>
                                            {getVehicleData(row)}
                                        </p>
                                    )} */}
                                    <p>
                                        <strong>{tableHeader[3]}:</strong> {row?.stratCity ?? 'N/A'}
                                    </p>
                                    <p>
                                        <strong>{tableHeader[4]}:</strong> {row?.pickupLocation ?? 'N/A'}
                                    </p>
                                    <p>
                                        <strong>{tableHeader[5]}:</strong>{' '}
                                        {standardDate(row?.createdAt?.split('T')[0]) ?? 'N/A'}
                                    </p>
                                    <p>
                                        <strong>{tableHeader[6]}:</strong> {row?.totalSeats ?? '0'}
                                    </p>
                                    <p
                                        style={{
                                            color:
                                                row?.amountPaid?.isReserved || row?.amountPaid?.isInstallment
                                                    ? 'red'
                                                    : '',
                                            textAlign: 'center',
                                            verticalAlign: 'middle'
                                        }}
                                    >
                                        {row?.amountPaid?.isReserved ? 'Reserved' : row?.amountPaid?.isInstallment ? 'Installment' : <>Full payment<br />Paid: ₹{Number(row?.amountPaid?.paid) || 0}</>}
                                    </p>
                                    <p>
                                        <strong>{tableHeader[7]}:</strong> {row?.transport ?? 'N/A'}
                                    </p>
                                    <p>
                                        <strong>{tableHeader[8]}:</strong> {row?.bookedVia ?? 'N/A'}
                                    </p>
                                    <p className={`cardLabelDisplay ${row.userDetails.length > 1 ? 'multiple' : ''}`}>
                                        <strong>{tableHeader[9]}:</strong> {getUserData(row)}
                                    </p>
                                </div>
                            </div>
                        ))}
                </div>
            </div>
            {showModal && (
                <ConfirmationModal
                    setShowModal={setShowModal}
                    handleConfirm={(e) => {
                        handleBookingCancel(e);
                    }}
                    message={'Do you want to cancel the booking?'}
                />
            )}
        </div>
    );
}
